import { FormInput } from '@ami/react/core';
import PropTypes from 'prop-types';
import React from 'react';
import InputMask from 'react-input-mask';
import AuthorizedListDealerGroupSettings from '../../dealer-users/components/authorization/AuthorizedListDealerGroupSettings';
import { FormCheckBox } from '@ami/react/core';

export default class DealerUserAddFormData extends React.Component {
  constructor(props) {
    super(props);
    this.updateDealerUser = this.updateDealerUser.bind(this);
    this.onChangeInviteUser = this.onChangeInviteUser.bind(this);
    this.handledAuthorizedDealerGroupsChanged =
      this.handledAuthorizedDealerGroupsChanged.bind(this);

    this.state = {
      expanded: false,
    };
  }
  static defaultProps = {
    enabledRemoveDealerGroup: true,
    enabledAddDealerGroup: true,
  };

  static propTypes = {
    dealerUser: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
    availableEmailTemplateTypes: PropTypes.array.isRequired,
    dealerUserChanged: PropTypes.func.isRequired,
    enabledRemoveDealerGroup: PropTypes.bool,
    enabledAddDealerGroup: PropTypes.bool,
    dealerGroup: PropTypes.object,
  };

  updateDealerUser(e) {
    const { dealerUserChanged, dealerUser } = this.props;
    dealerUserChanged({ ...dealerUser, [e.target.id]: e.target.value });
  }

  handledAuthorizedDealerGroupsChanged(authorizedDealerGroups) {
    const { dealerUserChanged, dealerUser } = this.props;
    dealerUserChanged({ ...dealerUser, authorizedDealerGroups });
  }

  onChangeInviteUser(e) {
    const { dealerUserChanged, dealerUser } = this.props;
    dealerUserChanged({ ...dealerUser, inviteUser: e });
  }

  render() {
    const {
      dealerUser,
      permissions,
      availableEmailTemplateTypes,
      enabledRemoveDealerGroup,
      enabledAddDealerGroup,
      dealerGroup,
    } = this.props;
    return (
      <div>
        <div className="row">
          <div className="col-12 col-md-6">
            <FormInput
              id="fullName"
              label="Name"
              value={dealerUser.fullName}
              onChange={this.updateDealerUser}
              required
            />
          </div>
          <div className="col-12 col-md-6">
            <FormInput
              id="email"
              type="email"
              label="Email"
              value={dealerUser.email}
              onChange={this.updateDealerUser}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            <InputMask
              mask="(999) 999-9999"
              maskChar=" "
              value={dealerUser.phoneNumber}
              onChange={this.updateDealerUser}
            >
              {() => (
                <FormInput id="phoneNumber" type="tel" label="Phone Number" />
              )}
            </InputMask>
          </div>
          <div className="col-12 col-md-6">
            <FormCheckBox
              label="Invite User"
              checkboxLabel="Invite user to join Blackbird?"
              checked={dealerUser.inviteUser}
              onChange={this.onChangeInviteUser}
            />
          </div>
        </div>
        <AuthorizedListDealerGroupSettings
          dealerUser={dealerUser}
          permissions={permissions}
          availableEmailTemplateTypes={availableEmailTemplateTypes}
          onAuthorizedDealerGroupsChanged={
            this.handledAuthorizedDealerGroupsChanged
          }
          enabledRemove={enabledRemoveDealerGroup}
          enabledAdd={enabledAddDealerGroup}
          dealerGroup={dealerGroup}
        />
      </div>
    );
  }
}
